// extracted by mini-css-extract-plugin
module.exports = {"custom-scroll":"CustomScroll_custom-scroll__UjWPh","disabled":"CustomScroll_disabled__b_2S8"};